import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '8px',
  padding: '8px',
  width: '408px'
}

const TestConfigChipOutdates = () =>
  <div style={wrapperStyle}>
    <Header
      hasNoTopMargin
      rank={4}
    >
      Parameter not available
    </Header>
    <Paragraph variant='word-break'>
      <Color variant='theme-description-text'>
        There is an issue with this test config step. Please click the chip for details.
      </Color>
    </Paragraph>
  </div>

export default TestConfigChipOutdates
